import { render, staticRenderFns } from "./HowItWorksNew.vue?vue&type=template&id=1835a11b&"
import script from "./HowItWorksNew.vue?vue&type=script&lang=js&"
export * from "./HowItWorksNew.vue?vue&type=script&lang=js&"
import style0 from "./HowItWorksNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports